import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

const getRecipientDisplayName = (recipient: EntitiesSupportedByEmailFeature): string =>
  `${recipient.name} <${recipient.email}>`;

export default getRecipientDisplayName;
